import { render, staticRenderFns } from "./LoadMissed.vue?vue&type=template&id=98c8747c&lang=pug"
import script from "./LoadMissed.vue?vue&type=script&lang=js"
export * from "./LoadMissed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports